import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Label, TextField, ChoiceGroup, DefaultButton, PrimaryButton, Stack } from '@bingads-webui-react/fabric-control';
import { HelpPopupInline } from '@bingads-webui-react/help-popup';

const getStyles = () => ({
  keywordEditor: {
    '& .ms-Stack': {
      marginTop: '36px',
    },
  },
});


const keywords = {
  TitleCase: 'KeyWord',
  SentenceCase: 'Keyword',
  LowerCase: 'keyword',
};

class UnstyledKeywordEditor extends React.PureComponent {
  constructor(props) {
    super(props);
    const {
      i18n, options,
    } = props;

    this.keywordCaseOptions = [
      { key: 'TitleCase', text: `${i18n.getString(_TL_('Title Case'))} ` },
      { key: 'SentenceCase', text: `${i18n.getString(_TL_('Sentence Case'))} ` },
      { key: 'LowerCase', text: `${i18n.getString(_TL_('Lower Case'))} ` },
    ];

    this.state = {
      keywordText: options.defaultText,
      keywordCase: options.keywordCase,
      defaultTextErrorMessage: '',
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.options.defaultText !== prevProps.options.defaultText) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ keywordText: this.props.options.defaultText });
    }
  }

  onCancel = () => {
    this.props.updateAndCloseCallback(({ isCancel: true }));
  };

  onSave = () => {
    const {
      options, updateAndCloseCallback, i18n,
    } = this.props;

    if (_.isEmpty(this.state.keywordText)) {
      this.setState({
        defaultTextErrorMessage: i18n.getString(_TL_('Default text is required.')),
      });
      return;
    }

    const { prefix, suffix } = options;

    const keywordCaseText = keywords[this.state.keywordCase];

    const newValue = `${prefix}{${keywordCaseText}:${this.state.keywordText}}${suffix}`;
    const cursorPosition = newValue.length - options.suffix.length;
    updateAndCloseCallback({
      newValue,
      cursorPosition,
      isSelectedByUser: true,
    });
  };

  onDefaultTextChange = (event) => {
    this.setState({ keywordText: event.target.value });
    if (!_.isEmpty(event.target.value)) {
      this.setState({
        defaultTextErrorMessage: '',
      });
    } else {
      this.setState({
        defaultTextErrorMessage: this.props.i18n.getString(_TL_('Default text is required.')),
      });
    }
  };

  render() {
    const {
      i18n, classes,
    } = this.props;

    return (
      <div className={classNames(classes.keywordEditor, 'keyword-editor')} role="dialog">
        <Label htmlFor="keyword-default-text-input">
          {i18n.getString(_TL_('Default text'))}
          <HelpPopupInline
            topic="pop_BA_NewAdCreate_KWInsert_DefaultText"
            ariaLabel={i18n.getString(_TL_('Click to learn more about {{item}}', { item: i18n.getString(_TL_('Syntax')) }))}
          />
        </Label>
        <TextField
          validateOnLoad={false}
          id="keyword-default-text-input"
          value={this.state.keywordText}
          onChange={this.onDefaultTextChange}
          errorMessage={this.state.defaultTextErrorMessage}
        />
        <Label htmlFor="keyword-case-radio-group">
          {i18n.getString(_TL_('Case'))}
          <HelpPopupInline
            topic="pop_BA_NewAdCreate_KWInsert_Case"
            ariaLabel={i18n.getString(_TL_('Click to learn more about {{item}}', { item: i18n.getString(_TL_('Syntax')) }))}
          />
        </Label>
        <ChoiceGroup
          id="keyword-case-radio-group"
          options={this.keywordCaseOptions}
          selectedKey={this.state.keywordCase}
          onChange={(event, option) => { this.setState({ keywordCase: option.key }); }}
        />
        <Stack horizontal gap={12}>
          <PrimaryButton className="save" text={i18n.getString(_TL_('Set'))} onClick={() => this.onSave()} />
          <DefaultButton className="cancel" text={i18n.getString(_TL_('Cancel'))} onClick={() => this.onCancel()} />
        </Stack>
      </div>);
  }
}

UnstyledKeywordEditor.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  classes: PropTypes.shape({
    keywordEditor: PropTypes.string.isRequired,
  }).isRequired,
  options: PropTypes.shape({
    defaultText: PropTypes.string.isRequired,
    keywordCase: PropTypes.string.isRequired,
  }).isRequired,
  updateAndCloseCallback: PropTypes.func.isRequired,
};

const KeywordEditor = withDefaultStyles(UnstyledKeywordEditor, getStyles);
export default KeywordEditor;
